// Message code define
export const LevelSkillMessageCode = {
  LevelSkillManagement: {
    successGetData: '20000',
    successPutData: '20000',
    successDeleteData: '20000',
    successPostData: '20001',
  },
}

// Endpoint
export const LevelSkillEndPoint = {
  LevelSkillManagement: {
    request: 'hr/v1/levelskill',
  },
}
